import {useState} from "react";
import {PhoneHQGlyph, PhoneHQTooltip, PhoneHQCombobox} from 'ch3-ui-lib';
import {Queue, useGetQueuesQuery} from "../../../store/features/CallQueue/CallQueueService";
import {selectorItem} from "../../../utilis/types/Types";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";

export interface CallQueueModalProps {
    setQueue: Function;
    selectedQueue: Queue | undefined;
}

export const CallQueueModal = ({setQueue, selectedQueue }: CallQueueModalProps) => {
    const [pickedQueue, setPickedQueue] = useState<string | undefined>();

    const role = useSelector((state: any) => state.auth.role);
    const handlePhraseChange = (phrase: string) => {
        list.filter((item) => item.label?.toLowerCase().includes(phrase.toLowerCase()));
    }
    const {data: callQueue = []} = useGetQueuesQuery();

    const list: selectorItem[] = callQueue
        ?.map((queue: Queue) => ({
            label: queue.name,
            value: queue.id?.toString() ?? '',
            key: queue.id?.toString() ?? '',
        }))
        .filter((item) => item.value !== '' && item.key !== '');

    return (
        <div className='w-[400px]'>
            <div>
                The call will be routed to the appropriate queue based on predefined criteria.
            </div>
            <div  className='my-4'>
                <PhoneHQCombobox
                    label="Choose queue"
                    placeholder="Search queues"
                    onInputChange={handlePhraseChange}
                    value={pickedQueue ?? selectedQueue?.id?.toString()}
                    onSelect={(item) => {
                        setPickedQueue(item.value);
                        setQueue(Number(item.value));
                    }}
                    items={list}
                />
                {role === 'ADMIN' &&  <div className={'text-end mb-8 text-sm'}>
                    Can't find queue? <span className='text-brand-ink cursor-pointer'><Link to={'/callQueues/new'}>Create a new queue</Link> </span>
                </div>}
                {role !== 'ADMIN'  && !list.length &&  <div className={'text-end mb-8 justify-end flex gap-3'}>
                    <div className={'flex gap-3 text-sm'}>
                        No queues available for you.
                    </div>
                    <PhoneHQTooltip content={"You don't have permission to create a new queue. Please contact your  admin." }><div>
                            <PhoneHQGlyph name='question_mark' size={12} className='bg-black text-white'/>
                        </div></PhoneHQTooltip>

                </div>}
            </div>

        </div>


    );
}
